import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useForm from "../../../lib/useForm"
import Loading from 'lib/loading'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FormPlanoContas = ({ fechaModal, planoContas_id}) => {

  //valores iniciais do formulario
  const inicialForm = {
    plano_contas_id: '',
    plano_contas: ''
  }

  const [form, onChange, setForm] = useForm(inicialForm)
  const [loading, setLoading]     = useState(true)

  //preenche setform e formulario
  const editPlanoContas = (planoContas_id) => {
    const url     = rotas.planoContas+planoContas_id,
          retorno = rest.get(url)

    retorno.then(ret => {
      if (ret.success) {
        setForm(ret.lista[0])
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if(planoContas_id != ''){
      editPlanoContas(planoContas_id)
    }else{
      setForm(inicialForm)
      setLoading(false)
    }
  },[])

  const excluir = () => {
    if(planoContas_id != ''){

      formSwal.queue([{
        title:                'Deseja excluir o favorecido ?',
        confirmButtonText:    'SIM',
        showCancelButton:     true,
        text:                 'Essas informações serão excluidas do banco',
        showLoaderOnConfirm:  true,
        cancelButtonColor:    '#d33',
        preConfirm: () => {
          // setLoading(true)
          const param = {'planoContas_id': planoContas_id}
          const url = rotas.planoContas+planoContas_id
          try{
            const retorno = rest.del(url, param)
            retorno.then(ret => {
              if (ret.success && ret.success == 'S') {
                formSwal.fire('Salvo!', ret.msg, 'success')
                fechaModal()
              }else{
                formSwal.fire('Erro!',ret.msg,'error')
              }
            })
            return (true)
          }catch(err){
            console.log(err)
            formSwal.fire('Erro!',err,'error')
          }
        }
      }])
    }
  }

  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault()

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.planoContas+'gravar.php'
        if(planoContas_id !== ''){
          return rest.post(url, form)
            .then(ret => {
              if (ret.success == 'S') {
                editPlanoContas(planoContas_id)
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
            })
        }else{
          return rest.put(url, form)
            .then(ret => {
              if (ret.success == 'S') {
                editPlanoContas(ret.retorno.insert_id)
                formSwal.fire('Salvo!',
                              ret.msg,
                              'success')
              }else{
                formSwal.fire('Erro!',
                              ret.msg,
                              'error')
              }
            })
        }
      }
    }])
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading
          tipo='componente'
        />
      </ModalBody>
    )
  }else {
    return (
      <FormGroup onSubmit={handleSubmit} className="formCadastro">
        <ModalBody className="pb-0">
          <Form>
            <Row>
              <Col md ='2'>
                <FormGroup>
                  <Label for="planoContas_id">Código</Label>
                  <Input
                    disabled
                    style     = {{background: '#F9F9F9'}}
                    name      = "planoContas_id"
                    id        = "planoContas_id"
                    value     = {form.plano_contas_id}
                    onChange  = {onChange('plano_contas_id')}
                  />
                </FormGroup>
              </Col>
              <Col md ='10'>
                <FormGroup>
                  <Label for="planoContas">Plano de Contas</Label>
                  <Input
                    name        = "planoContas"
                    id          = "planoContas"
                    maxLength   = {50}
                    value       = {form.plano_contas}
                    onChange    = {onChange('plano_contas')}
                    placeholder = "Nome do plano de contas..."
                  />
                </FormGroup>
              </Col>
            </Row>

            <Col className="text-center p-3">
              <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
              <Button type="button" className="mb-0 mt-0" color="danger" size="md" onClick={() => excluir()}>Excluir</Button>
              <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
            </Col>

          </Form>
        </ModalBody>
      </FormGroup>
    )
  }


}

export default FormPlanoContas
